import { computed, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EditPortfolioConfirmationDetailsComponent } from './edit-portfolio-confirmation-details/edit-portfolio-confirmation-details.component';
import { UpdateWatchlistConfirmationDetailsComponent } from './update-watchlist-confirmation-details/update-watchlist-confirmation-details.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
function AgentToolPermissionBoxComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-update-watchlist-confirmation-details", 2);
} if (rf & 2) {
    i0.ɵɵproperty("details", ctx);
} }
function AgentToolPermissionBoxComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-edit-portfolio-confirmation-details", 2);
} if (rf & 2) {
    i0.ɵɵproperty("details", ctx);
} }
export class AgentToolPermissionBoxComponent {
    constructor() {
        this.toolCall = input.required(...(ngDevMode ? [{ debugName: "toolCall" }] : []));
        this.confirm = output();
        this.alwaysApply = model(false, ...(ngDevMode ? [{ debugName: "alwaysApply" }] : []));
        this.displayName = computed(() => this.toolCall().display_name || this.toolCall().name, ...(ngDevMode ? [{ debugName: "displayName" }] : []));
        this.details = computed(() => this.toolCall().details ?? null, ...(ngDevMode ? [{ debugName: "details" }] : []));
        this.updateWatchlistDetails = computed(() => {
            const details = this.details();
            return details?.kind === 'update_watchlist' ? details : null;
        }, ...(ngDevMode ? [{ debugName: "updateWatchlistDetails" }] : []));
        this.editPortfolioDetails = computed(() => {
            const details = this.details();
            return details?.kind === 'edit_portfolio' ? details : null;
        }, ...(ngDevMode ? [{ debugName: "editPortfolioDetails" }] : []));
        // A details preview that failed to build carries an error; block the user from approving it.
        this.hasError = computed(() => !!this.details()?.error, ...(ngDevMode ? [{ debugName: "hasError" }] : []));
    }
    authorize() {
        this.confirm.emit({ authorize: true, alwaysApply: this.alwaysApply() });
    }
    reject() {
        this.confirm.emit({ authorize: false, alwaysApply: this.alwaysApply() });
    }
}
AgentToolPermissionBoxComponent.ɵfac = function AgentToolPermissionBoxComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentToolPermissionBoxComponent)(); };
AgentToolPermissionBoxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentToolPermissionBoxComponent, selectors: [["ycn-agent-tool-permission-box"]], inputs: { toolCall: [1, "toolCall"], alwaysApply: [1, "alwaysApply"] }, outputs: { confirm: "confirm", alwaysApply: "alwaysApplyChange" }, decls: 20, vars: 5, consts: [[1, "pt-3", "pr-20", "pb-3", "pl-20", "bg-white", "rounded-4", "mt-20"], [1, "text-large", "leading-relaxed"], [3, "details"], [1, "row", "mt-3", "mb-10"], [1, "col-6"], [1, "btn", "btn-secondary", "btn-block", 3, "click"], [1, "btn", "btn-primary", "btn-block", 3, "click", "disabled"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function AgentToolPermissionBoxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2, "Please confirm I have permission to ");
        i0.ɵɵelementStart(3, "strong");
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(5, " on your behalf. ");
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(6, AgentToolPermissionBoxComponent_Conditional_6_Template, 1, 1, "ycn-update-watchlist-confirmation-details", 2);
        i0.ɵɵconditionalCreate(7, AgentToolPermissionBoxComponent_Conditional_7_Template, 1, 1, "ycn-edit-portfolio-confirmation-details", 2);
        i0.ɵɵelementStart(8, "div", 3)(9, "div", 4)(10, "button", 5);
        i0.ɵɵlistener("click", function AgentToolPermissionBoxComponent_Template_button_click_10_listener() { return ctx.reject(); });
        i0.ɵɵtext(11, "Reject");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 4)(13, "button", 6);
        i0.ɵɵlistener("click", function AgentToolPermissionBoxComponent_Template_button_click_13_listener() { return ctx.authorize(); });
        i0.ɵɵtext(14, "Allow");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(15, "label", 7)(16, "input", 8);
        i0.ɵɵtwoWayListener("ngModelChange", function AgentToolPermissionBoxComponent_Template_input_ngModelChange_16_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.alwaysApply, $event) || (ctx.alwaysApply = $event); return $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(17, "span", 9);
        i0.ɵɵelementStart(18, "span", 10);
        i0.ɵɵtext(19, "Always apply this answer");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        let tmp_1_0;
        let tmp_2_0;
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.displayName());
        i0.ɵɵadvance(2);
        i0.ɵɵconditional((tmp_1_0 = ctx.updateWatchlistDetails()) ? 6 : -1, tmp_1_0);
        i0.ɵɵadvance();
        i0.ɵɵconditional((tmp_2_0 = ctx.editPortfolioDetails()) ? 7 : -1, tmp_2_0);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.hasError());
        i0.ɵɵadvance(3);
        i0.ɵɵtwoWayProperty("ngModel", ctx.alwaysApply);
    } }, dependencies: [FormsModule, i1.CheckboxControlValueAccessor, i1.NgControlStatus, i1.NgModel, EditPortfolioConfirmationDetailsComponent, UpdateWatchlistConfirmationDetailsComponent], encapsulation: 2, changeDetection: 0 });
